import { api } from "../common/api";
import { useEffect, useState } from "react";
import StatCard from "../components/StatCard";
import { SettingOutlined } from "@ant-design/icons";

export default function () {
  const [dpiCounter, setDpiCounter] = useState(0);
  useEffect(() => {
    api.employeeRequiredDpi
      .list({ notOk: true })
      .then((data) => setDpiCounter(data.count));
  }, []);
  return (
    <StatCard
      icon={<SettingOutlined />}
      title="DPI Mancanti"
      secondary={"DPI non consegnati"}
      stat={dpiCounter}
    />
  );
}
